import {isEmpty} from 'lodash';
import {Logger} from '../../utils/Logger';
import {MatSort} from '@angular/material/sort';
import {MatDialog} from '@angular/material/dialog';
import {Toaster, Type} from '../../toaster/Toaster';
import {ActivatedRoute, Router} from '@angular/router';
import {MatPaginator} from '@angular/material/paginator';
import {TermsComponent} from '../../terms/terms.component';
import {Component, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {ApiServiceService} from '../../api-service.service';
import {ChartData} from '../../doughnut/doughnut.component';
import {XirrCalculator} from '../../service/xirr-calculator';
import {ChartDataUtil} from '../../doughnut/chart-data.util';
import {PortfolioType} from '../../model/portfolio-type.model';
import {PortfolioService} from '../../service/portfolio.service';
import {Keys, StorageService} from '../../service/storage.service';
import {GaugedInvestment} from '../../model/gauged-investment.model';
import {EntityConflictError} from '../../errors/EntityConflictError';
import {SelectedInvestments} from '../../model/selected-investments.model';
import {InsufficientWalletBalanceError} from '../../errors/insufficient-wallet-balance.error';
import {ConfirmPopUpComponent, ConfirmPopUpData} from '../../comfirm-pop-up/confirm-pop-up.component';
import {ManualInvestPortfolioCreationData} from '../../model/portfolio-creation-data/manual-invest-portfolio-creation-data.model';

export interface SavedPreference {
    ratingList: string[];
}

@Component({
    selector: 'app-manualinvestsummary',
    templateUrl: './manualinvestsummary.component.html',
    styleUrls: ['./manualinvestsummary.component.css'],
    providers: [ApiServiceService, PortfolioService]
})
export class ManualinvestsummaryComponent implements OnInit {
    data: Array<any>;
    fractionSize: any;
    hideConfirmPortfolio = true;

    displayedColumns: any = ['roi', 'city', 'rating', 'amount', 'filled_percentage', 'loan_reason'];

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    dataSource: any;

    public loader = false;
    public expectedRoi: number;
    public portolioToConfirm: any = [];
    public manualInvestTitle: string;
    public manualInvestAmount: number;
    public manualInvestType: PortfolioType;
    public manualInvestSummaryError = false;
    public manualInvestSummaryErrorMsg: string;
    public manualInvestRemainingAmount: number;
    public chartData: ChartData[];
    private readonly chartDataUtil: ChartDataUtil;
    private readonly activatedRoute: ActivatedRoute;
    private readonly xirrCalculator: XirrCalculator;
    private readonly portfolioService: PortfolioService;
    private manualInvestmentPortfolioCreationData: ManualInvestPortfolioCreationData;

    constructor(private router: Router, activatedRoute: ActivatedRoute, public dialog: MatDialog,
                private storageService: StorageService, portfolioService: PortfolioService,
                xirrCalculator: XirrCalculator, chartDataUtil: ChartDataUtil) {
        this.activatedRoute = activatedRoute;
        this.portfolioService = portfolioService;
        this.xirrCalculator = xirrCalculator;
        this.chartDataUtil = chartDataUtil;
        activatedRoute.data.subscribe(({portfolioCreationData}: { portfolioCreationData: ManualInvestPortfolioCreationData }) => {
            this.onPortfolioCreationDataReceived(portfolioCreationData);
        });
    }

    openDialog() {
        this.dialog.open(TermsComponent, {height: '500px', width: '600px'});
    }

    goBack() {
        const portfolioType = this.manualInvestmentPortfolioCreationData.portfolioType;
        const routeUrl = (portfolioType === PortfolioType.HybridInvest || portfolioType === PortfolioType.AutoInvest) ? '../portfolio-preference' : '../';
        this.router.navigate([routeUrl], {relativeTo: this.activatedRoute});
    }

    async confirmPortfolio(): Promise<void> {
        this.showLoader();
        this.hideConfirmPortfolio = false;

        this.manualInvestSummaryError = false;
        const manualInvestPortfolioCreationData = this.manualInvestmentPortfolioCreationData;
        const gaugedInvestments = manualInvestPortfolioCreationData.selectedInvestments.map(selectedInvestment => {
            const gaugedInvestment = selectedInvestment.gaugedInvestment;
            return new GaugedInvestment(gaugedInvestment.loan, gaugedInvestment.portfolio, selectedInvestment.amount);
        });

        const portfolioName = manualInvestPortfolioCreationData.portfolioName;
        const portfolioType = manualInvestPortfolioCreationData.portfolioType;
        const investmentAmount = manualInvestPortfolioCreationData.portfolioAmount;
        const portfolioPreference = manualInvestPortfolioCreationData.portfolioPreference;
        const lenderExposureForBorrower = this.storageService.getObjectFromSession<boolean>(Keys.LENDER_50K_LIMIT_CHECK);
        const lenderLoanAgreementCheck = this.storageService.getObjectFromSession<boolean>(Keys.LENDER_LOAN_AGREEMENT_REVIEWED);
        const lenderExposureAcrossP2PPlatforms = this.storageService.getObjectFromSession<boolean>(Keys.LENDER_10LAKH_LIMIT_CHECK);
        const isPreFlex = this.storageService.getItem(Keys.FINX) === "true" && this.storageService.getItem(Keys.IS_LENDER_CREATED_AFTER_RESTRICTED_DATE) === "true";
        const preFlexAggrement: boolean = this.storageService.getObjectFromSession(Keys.FINZY_FLEX_PRE_LAUNCH_AGGREMENT);
        try {
            await this.portfolioService.createPortfolio(gaugedInvestments, lenderLoanAgreementCheck, lenderExposureForBorrower,
                lenderExposureAcrossP2PPlatforms, portfolioType, investmentAmount, portfolioName, portfolioPreference, (isPreFlex) && preFlexAggrement);
            await this.portfolioService.removeLocalPortfolioCreationData(this.manualInvestmentPortfolioCreationData.tempPortfolioId);
            await this.router.navigate(['/investordashboard']);
        } catch (err) {
            this.hideLoader();
            if (err instanceof EntityConflictError) {
                Logger.log(`One or more of the selected loans are not available anymore.`);
                this.openLoanUnavailableDialog();
            } else if (err instanceof InsufficientWalletBalanceError) {
                Logger.log(`Wallet Balance is insufficient.`);
                this.openInsufficientWalletBalanceDialog();
            } else {
                Toaster.toast(`Something went wrong. Please try again later.`, Type.Error);
            }
        }
    }

    onTitleChanged(title: string) {
        const manualInvestmentPortfolioCreation = this.manualInvestmentPortfolioCreationData;
        manualInvestmentPortfolioCreation.portfolioName = title;
    }

    async ngOnInit() {
        const manualInvestmentPortfolioCreation = this.manualInvestmentPortfolioCreationData;
        this.expectedRoi = await this.calculateXirr(manualInvestmentPortfolioCreation);
        this.manualInvestType = manualInvestmentPortfolioCreation.portfolioType;
        this.manualInvestTitle = manualInvestmentPortfolioCreation.portfolioName;
        this.manualInvestAmount = manualInvestmentPortfolioCreation.portfolioAmount;
        this.manualInvestRemainingAmount = manualInvestmentPortfolioCreation.portfolioAmount - manualInvestmentPortfolioCreation.selectedInvestments.allocatedAmount();

        this.portolioToConfirm = manualInvestmentPortfolioCreation.selectedInvestments.map(investment => {
            return {
                amount: investment.amount,
                ...investment.gaugedInvestment.loan
            };
        });
        this.populateChartData(manualInvestmentPortfolioCreation.selectedInvestments);

        // populate datatable
        this.data = this.portolioToConfirm;

        setTimeout(() => {
            this.dataSource = new MatTableDataSource(this.data);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
        }, 500);
    }

    hasUserChosenPreferences(): boolean {
        const portfolioCreationData = this.manualInvestmentPortfolioCreationData;
        return !!portfolioCreationData.portfolioPreference;
    }

    public onLoanUnavailableDialogClosed(): void {
        this.router.navigate(['../'], {relativeTo: this.activatedRoute});
    }

    public async onInsufficientWalletBalanceDialogClosed(): Promise<void> {
        await this.portfolioService.removeLocalPortfolioCreationData(this.manualInvestmentPortfolioCreationData.tempPortfolioId);
        this.router.navigate(['/investordashboard']);
    }

    public onPortfolioCreationDataReceived(portfolioCreationData: ManualInvestPortfolioCreationData): void {
        this.manualInvestmentPortfolioCreationData = portfolioCreationData;
    }

    public areSelectedInvestmentsAvailable(): boolean {
        return !isEmpty(this.manualInvestmentPortfolioCreationData.selectedInvestments);
    }

    getSubtitleText(): string {
        if (this.areSelectedInvestmentsAvailable()) {
            return this.hasUserChosenPreferences() ? `We` : `finzyPRO+`;
        } else {
            return this.hasUserChosenPreferences() ? `Custom finzyPRO+.` : `finzyPRO+.`;
        }
    }

    getContent(): string {
        if (this.areSelectedInvestmentsAvailable()) {
            if (this.hasUserChosenPreferences()) {
                return `We have retained the loans manually picked by you. You can view them below. You have chosen to invest the remaining amount of ₹ ${this.manualInvestRemainingAmount} via custom preferences. We will allot this amount to new loans that get listed on finzy that belong to following rating categories chosen by you.`;
            } else {
                return `We have retained the loans manually picked by you. You can view them below. We will auto-invest the remaining amount of ₹ ${this.manualInvestRemainingAmount} in new loans that get listed on finzy. We have multiple new loans listed everyday.`;
            }
        } else {
            if (this.hasUserChosenPreferences()) {
                return `You have chosen to invest the amount of ₹ ${this.manualInvestRemainingAmount} in new loans with custom preferences. We will allot this amount to new loans that get listed on finzy that belong to following rating categories chosen by you.`;
            } else {
                return `We will auto-invest your investment amount of ₹ ${this.manualInvestRemainingAmount} as they get listed on finzy. We will allot this amount to new loans listed everyday by identifying the best suited loans for your investment.`;
            }
        }
    }

    public populateChartData(selectedInvestments: SelectedInvestments) {
        const investments = selectedInvestments.map(selectedInvestment => ({
            rating: selectedInvestment.gaugedInvestment.loan.rating,
            amount: selectedInvestment.amount
        }));
        this.chartData = this.chartDataUtil.convertToChartDataForInvestments(investments);
    }

    private async calculateXirr(manualInvestmentPortfolioCreation: ManualInvestPortfolioCreationData) {
        return await this.xirrCalculator.calculateForInvestments(manualInvestmentPortfolioCreation.selectedInvestments.map(selectedInvestment => {
            return {
                investmentAmount: selectedInvestment.amount,
                roi: selectedInvestment.gaugedInvestment.loan.roi,
                tenure: selectedInvestment.gaugedInvestment.loan.loan_tenure
            };
        }));
    }

    private openInsufficientWalletBalanceDialog(): void {
        this.dialog.open(ConfirmPopUpComponent, {
            data: <ConfirmPopUpData>{
                title: 'Insufficient Wallet Balance',
                message: 'Looks like there is insufficient wallet amount to create this portfolio.',
                positiveButtonText: 'RETURN TO DASHBOARD'
            },
            disableClose: true
        }).afterClosed().subscribe(() => this.onInsufficientWalletBalanceDialogClosed());
    }

    private openLoanUnavailableDialog(): void {
        this.dialog.open(ConfirmPopUpComponent, {
            data: <ConfirmPopUpData>{
                title: 'Oops! Portfolio could not be created!',
                message: 'One or more loans that you have selected as a part of your portfolio are not available anymore. Don\'t' +
                    ' worry, you can choose other loans as replacement. We have retained all other loans selected by you.',
                positiveButtonText: 'PICK NEW LOANS'
            },
            disableClose: true
        }).afterClosed().subscribe(() => this.onLoanUnavailableDialogClosed());
    }

    private showLoader() {
        this.loader = true;
    }

    private hideLoader() {
        this.loader = false;
    }
}
